export default function paymentCompleteController(
    $scope,
    paymentService,
    Basket,
    Bookings,
    CheckoutErrors
) {
    $scope.bookingError = { error: false };

    const url = new URL(window.location.href);
    const paymentId = url.searchParams.get("paymentid");

    if (paymentId) {
        paymentService.getByPaymentID(paymentId).then(
            (payment) => {
                if (!payment.bookingId) {
                    $scope.bookingError = CheckoutErrors.getBookingError({
                        error: true,
                        type: "no-booking-id-in-basket",
                    });
                    return;
                }
                Bookings.get(payment.bookingId).then((booking) => {
                    handleBookings(booking);
                });
                handleApiPaymentResponse(payment);
            },
            () => {
                $scope.bookingError = CheckoutErrors.getBookingError({
                    error: true,
                    type: "booking-payment-api-error",
                });
            }
        );

        // Clear basket
        Basket.resetBasket();
    }

    const handleBookings = (booking) => {
        if (!booking.bookingPeriods.length) {
            $scope.bookingError = CheckoutErrors.getBookingError({
                error: true,
                type: "booking-expired",
            });
            return;
        }

        // Only show latest completed booking periods - used in fixed bookings
        const lastBookingPeriodCompletedOn =
            booking.bookingPeriods[booking.bookingPeriods.length - 1]
                .completedOn;

        booking.bookingPeriods = booking.bookingPeriods.filter(
            (x) => x.completedOn == lastBookingPeriodCompletedOn
        );
        $scope.booking = booking;
    };

    const handleApiPaymentResponse = (payment) => {
        $scope.payment = payment;
        if (!payment.paymentStatusMessage) {
            $scope.payment.paymentStatusMessage =
                "Din booking er ikke betalt endnu - betalings ID: " +
                payment.orderNumber;
        }
    };
}
